import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { putApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { FaultTypesForm } from '../../forms/faultTypes/FaultTypesForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { FaultType, FaultTypeInputs } from '../../types/faultType';
import { DetailPageParams } from '../../types/pageParams.types';
import { API_URL, fetcher } from '../../utils/apiUrl';

export function FaultTypesEdit() {
  const { translate } = useTranslation();
  const transFormName = 'FaultType.Update';
  const { startLoading, stopLoading } = useLoading();
  const { id } = useParams<DetailPageParams>();
  const { data, error } = useSWR<FaultType>(`${API_URL.FAULT_TYPE_ITEM}?id=${id}`, fetcher);
  const [formData, setFormData] = useState<FaultTypeInputs>();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Edit fault type',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Fault types', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  useEffect(() => {
    if (!data) return;

    setFormData({
      ...data,
    });
  }, [data]);

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    if (!data) return;

    let isOk = false;
    startLoading();
    await putApi({
      url: API_URL.FAULT_TYPE_PUT,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper heading={translate!('Edit fault type', transFormName)}>
      <FaultTypesForm onSubmit={onSubmit} formData={formData} isEdit />
    </PageContentWrapper>
  );
}

export default FaultTypesEdit;
